import { CssBaseline, CssVarsProvider, extendTheme } from '@mui/joy'
import { SnackbarProvider } from 'notistack'
import './App.css'
// import {HomePage} from "./page/home/HomePage";
import { LandingPage } from './page/landing/LandingPage'
import {
    BrowserRouter,
    Route,
    Routes,
    useLocation,
} from 'react-router-dom'
import { TermsOfServicePage } from './page/tnc/TermsOfServicePage'
import { useEffect } from 'react'
import { PrivacyPolicyPage } from './page/tnc/PrivacyPolicyPage'

const customTheme = extendTheme({
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    // Override the default blue color with green shades
                    50: '#FEFCE8',
                    100: '#FEF9C3',
                    200: '#FEF08A',
                    300: '#FDE047',
                    400: '#FACC15',
                    500: '#EAB308',
                    600: '#CA8A04',
                    700: '#A16207',
                    800: '#854D0E',
                    900: '#422006',
                },
                // Optionally override secondary, info, success, etc.
            },
        },
    },
})

function ScrollToTop() {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}

function App() {
    return (
        <SnackbarProvider
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <CssBaseline>
                <CssVarsProvider theme={customTheme}>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route
                                path="/terms-of-service"
                                element={<TermsOfServicePage />}
                            />
                            <Route
                                path="/privacy-policy"
                                element={<PrivacyPolicyPage />}
                            />
                        </Routes>
                    </BrowserRouter>
                </CssVarsProvider>
            </CssBaseline>
        </SnackbarProvider>
    )
}

export default App
